import { connect } from 'react-redux'
import { IStore } from '../../../reducers'
import { getCalendarPreferences } from '../../../reducers/userObject/selectors/settings'

const mapStateToProps = (state: IStore) => {
  const { colors, shape } = getCalendarPreferences(state)
  return {
    colors,
    shape,
  }
}

export default connect(mapStateToProps)
